import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { ActiveWardrobeContext } from '../../contexts/ActiveWardrobeContext';
import { WardrobesConfigsContext } from '../../contexts/WardrobesConfigsContext';
import { ConfiguratorModeContext } from '../../contexts/ConfiguratorModeContext';
import { EventsDataContext } from '../../contexts/EventsDataContext';
import BrwScene from './threedee/BrwScene';
// import Labels from './twodee/Labels';
import ConfiguratorControlButtons from '../buttons/ConfiguratorControlButtons';
import WardrobeIcon from '../buttons/WardrobeIcon';
import PopUp from '../popup/PopUp';
import DoorTypesPopupContent from '../popup/DoorTypesPopupContent';
import MoveWardrobe from '../common/MoveWardrobe';
import WardrobeOptionsButtons from '../optionsButtons/WardrobeOptionsButtons';
import EditButton from '../buttons/EditButton';
import Loader, { state as LoaderState } from '../Loader';
import { measurements } from './threedee/utils';
import { MoveWardrobeContext } from '../../contexts/MoveWardrobeContext';

/**
 * Opcje dla configuratorMode
 * 1. konfiguracja korpusów
 * 2. rodzaj korpusu
 * 3. Fronty
 * 4. Pattern frontów
 * 5. Uchwyty
 * 6  Akcesoria strefa
 * 7. Akcesoria
 * 8. Summary
 * 9. Opcje szafy
 * 10. przesuwanie
 * 11. dodawanie szafy
 * @param props
 */
const Configurator = props => {
  // const { wardrobeHeight } = useContext(WardrobeHeightContext);
  const { wardrobesConfigs, setWardrobesConfigs } = useContext(WardrobesConfigsContext);
  const { activeWardrobe, setActiveWardrobe } = useContext(ActiveWardrobeContext);
  const { optionsVisibility, setOptionsVisibility } = useContext(EventsDataContext);
  const [status, setStatus] = useState(LoaderState.LOADING);
  const brwSceneRef = React.useRef(null);
  const { shifts, setShifts } = useContext(MoveWardrobeContext);

  // React.useEffect(() => {

  //   // if (brwSceneRef && brwSceneRef.current) {
  //     // console.log(brwSceneRef.current);
  //   // }
  // }, []);

  const changeStatus = status => {
    if (status === true) {
      setStatus(LoaderState.DEFAULT);
    } else {
      setStatus(LoaderState.LOADING);
    }
  };

  let [state, setState] = useState({
    overallScale: 1,
    overallWidth: 100,
    angleWidth: 0,
    firstDepth: 66,
    lastDepth: 66,
    activeFront: 'Front_0_0',
    activeZone: null,
    shiftIndex: null,
    cornerIndexes: [9, 10, 11],
    activeFrontPattern: 'normal',
    activeFronts: ['Front_0_0'],
    orbitMode: false,
    activeWardrobe: activeWardrobe,
    highlightedWardrobe: null,
    notHideWardrobe: null,
    opened: true,
    dimensions: false,
    wardrobesPositions: [],
  });

  const [internalState, setInternalState] = useState({
    hullTypeToAdd: 'normal',
    wardrobe: {},
  });

  const { currentConfiguratorMode, setCurrentConfiguratorMode } = useContext(
    ConfiguratorModeContext,
  );

  useEffect(() => {
    setZone('left');

    // const config = wardrobesConfigs[activeWardrobe];

    // if(config.is_hinged &&
    //   (config.dimensions.x === 103 ||
    //   config.dimensions.x === 50 ||
    //   config.dimensions.x === 97 ||
    //   config.dimensions.x === 66)
    //   ){
    //   setActiveFrontPanel('Ram_0_0');
    // }
  }, []);

  const changeBodyType = (type, wardrobe) => {
    setInternalState({
      ...internalState,
      hullTypeToAdd: type,
      wardrobe: wardrobe,
    });

    changeConfiguratorMode(11);
  };

  const setNotHighlightedWardrobe = index => {
    setState({
      ...state,
      notHighlightedWardrobe: index,
    });
  };

  const setHighlightedWardrobe = index => {
    setState({
      ...state,
      highlightedWardrobe: index,
    });
  };

  const refreshLabels = pos => {
    setState({
      ...state,
      labelsPositions: pos,
    });
  };

  const refreshScene = () => {};

  const addWardrobe = where => {
    let wardrobes = [...wardrobesConfigs];
    const cnt = wardrobes.length;
    let wardrobe = internalState.wardrobe;
    let position = 0;

    if (where === 'L') {
      wardrobes.unshift(wardrobe);
    } else {
      position = cnt;
      wardrobes.push(wardrobe);
    }

    if (wardrobe) {
      setWardrobes(wardrobes);
    }

    changeConfiguratorMode(2);
    setState({
      ...state,
      activeWardrobe: position,
    });

    setWardrobeActive(position);
    props.history.push('/wardrobe-body-configuration');
  };

  const toggleOpen = () => {
    setOpenDoorsState(state.opened);
  };

  const setZone = zoneName => {
    setState(prev => {
      return {
        ...prev,
        activeZone: zoneName,
      };
    });
  };

  const setOpenDoorsState = (open = false) => {
    setState(prev => {
      return {
        ...prev,
        opened: !open,
      };
    });
  };

  const toggleDimensions = () => {
    setState({
      ...state,
      dimensions: !state.dimensions,
    });
  };

  const setWardrobeActive = active => {
    setState({ ...state, activeWardrobe: active });
    setActiveWardrobe(parseInt(active));
    setOptionsVisibility({ ...optionsVisibility, optionsButton: true });
    document.body.classList.add('overlay');
  };

  const moveSegment = dir => {
    const currentIndex = parseInt(activeWardrobe);
    let configs = wardrobesConfigs;

    const moveToNewIndex = newIndex => {
      configs.splice(newIndex, 0, configs.splice(currentIndex, 1)[0]);
      setWardrobesConfigs(configs);
      setActiveWardrobe(parseInt(newIndex));
    };

    switch (dir) {
      case 'L':
        if (currentIndex > 0) {
          const newIndex = currentIndex - 1;
          moveToNewIndex(newIndex);
        }
        break;
      case 'R':
        if (currentIndex < configs.length - 1) {
          const newIndex = currentIndex + 1;
          moveToNewIndex(newIndex);
        }
        break;
      default:
        break;
    }
  };

  const changeConfiguratorMode = mode => {
    setCurrentConfiguratorMode(mode);
    // setState({ ...state });
    if (mode === 9) {
      document.body.classList.add('overlay');
    } else {
      document.body.classList.remove('overlay');
    }
  };

  const editSegment = action => {
    const active = activeWardrobe;
    const wardrobe = JSON.parse(JSON.stringify(wardrobesConfigs[active]));
    let wardrobes = [...wardrobesConfigs];

    switch (action) {
      case 'duplicate':
        // wardrobes.unshift(wardrobe);
        let randomStr = Math.random().toString(36).substring(7);
        wardrobe.id = wardrobe.id.slice(0, -6) + randomStr;
        wardrobes.splice(active, 0, wardrobe);
        if (wardrobe) {
          setWardrobes(wardrobes);
          setWardrobeActive(wardrobes.length - 1);
          setOptionsVisibility({ ...optionsVisibility, optionsButton: false });
        }
        break;
      case 'edit':
        setWardrobeActive(activeWardrobe);
        props.history.push('/wardrobe-body-configuration');
        break;
      case 'delete':
        wardrobes.splice(active, 1);
        setWardrobeActive(0);
        setWardrobes(wardrobes);
        setOptionsVisibility({ ...optionsVisibility, optionsButton: false });
        break;
      default:
    }

    setOptionsVisibility({ ...optionsVisibility, optionsButton: false });
  };

  const setWardrobes = wardrobes => {
    const wardrobesCopy = JSON.parse(JSON.stringify(wardrobes));
    setState(prev => {
      return {
        ...prev,
        wardrobesConfigs: wardrobesCopy,
        shoppingList: wardrobesCopy,
      };
    });
    setWardrobesConfigs(wardrobesCopy);
  };

  const setActiveFrontPanel = segmentId => {
    setState({ ...state, activeFront: segmentId });
  };

  const setFrontPattern = pattern => {
    setState({ ...state, activeFrontPattern: pattern });
  };

  const setActiveFrontsPanels = pattern => {
    setState({ ...state, activeFronts: pattern });
  };

  const setOverallWidth = width => {
    setState({ ...state, overallWidth: width });
  };

  useEffect(() => {
    const cornerIndex = wardrobesConfigs.findIndex(config => config.is_corner === true);
    const wardrobes = wardrobesConfigs.length;
    const wardrobe = wardrobesConfigs[activeWardrobe];
    const wardrobeDimZ = wardrobe.dimensions.z;
    const wardrobePlusOne = wardrobesConfigs[activeWardrobe + 1];
    const wardrobeMinusOne = wardrobesConfigs[activeWardrobe - 1];
    const wardrobeMinusTwo = wardrobesConfigs[activeWardrobe - 2];
    const wardrobePlusTwo = wardrobesConfigs[activeWardrobe + 2];
    const wardrobeMinusTwoDimZ =
      wardrobeMinusTwo !== undefined ? wardrobeMinusTwo.dimensions.z : null;
    const wardrobeMinusOneDimZ =
      wardrobeMinusOne !== undefined ? wardrobeMinusOne.dimensions.z : null;
    const wardrobePlusOneDimZ = wardrobePlusOne !== undefined ? wardrobePlusOne.dimensions.z : null;
    const wardrobePlusTwoDimZ = wardrobePlusTwo !== undefined ? wardrobePlusTwo.dimensions.z : null;

    if (cornerIndex !== -1) {
      const corner = wardrobesConfigs[cornerIndex];
      const x = corner.dimensions.x;
      if (x === 103) {
        if (activeWardrobe === 0) {
          setShifts({ shift: !shifts.shift, left: false, right: true });
        }
        if (wardrobes - 1 === activeWardrobe) {
          setShifts({ shift: !shifts.shift, left: true, right: false });
        }
        if (wardrobePlusOne !== undefined && wardrobeMinusOne !== undefined) {
          setShifts({ shift: !shifts.shift, left: true, right: true });
        }
      }
      if (x === 97 || x === 66) {
        if (cornerIndex < activeWardrobe) {
          if (wardrobeMinusTwo !== undefined && activeWardrobe - 2 !== cornerIndex) {
            if (
              (wardrobeMinusTwoDimZ === 45 && wardrobeDimZ !== 66) ||
              (wardrobeMinusOne.is_corner && wardrobeMinusTwoDimZ === 45)
            ) {
              setShifts({ shift: !shifts.shift, left: false, right: true });
            }
            if (
              (activeWardrobe + 1 === wardrobes && wardrobeMinusOneDimZ === wardrobeDimZ) ||
              (activeWardrobe - 1 === cornerIndex &&
                wardrobeDimZ === 66 &&
                wardrobeMinusTwoDimZ !== 45)
            ) {
              setShifts({ shift: !shifts.shift, left: true, right: false });
            }
            if (
              (wardrobePlusOne !== undefined &&
                wardrobeMinusOne !== undefined &&
                activeWardrobe - 1 !== cornerIndex) ||
              (wardrobeMinusOneDimZ === 66 && wardrobePlusOne !== undefined)
            ) {
              setShifts({ shift: !shifts.shift, left: true, right: true });
            }
            if (
              (activeWardrobe + 1 === wardrobes &&
                wardrobeDimZ === 45 &&
                activeWardrobe - 1 === cornerIndex) ||
              (wardrobeMinusTwoDimZ === 45 &&
                activeWardrobe + 1 === wardrobes &&
                activeWardrobe - 1 === cornerIndex) ||
              (wardrobeDimZ === 45 &&
                activeWardrobe + 1 === wardrobes &&
                activeWardrobe - 1 === cornerIndex)
            ) {
              setShifts({ shift: !shifts.shift, left: false, right: false });
            }
          } else {
            if (
              (wardrobes - 1 === activeWardrobe && activeWardrobe - 1 === cornerIndex) ||
              (wardrobeDimZ === 45 && wardrobePlusOne === undefined) ||
              (wardrobeDimZ === 45 &&
                activeWardrobe + 1 === wardrobes &&
                activeWardrobe - 1 === cornerIndex)
            ) {
              setShifts({ shift: !shifts.shift, left: false, right: false });
            }
            if (wardrobePlusOne !== undefined && wardrobeMinusOne !== undefined) {
              setShifts({ shift: !shifts.shift, left: true, right: true });
            }
            if (activeWardrobe + 1 === wardrobes && wardrobeDimZ === 66) {
              setShifts({ shift: !shifts.shift, left: true, right: false });
            }
            if (
              activeWardrobe - 1 === cornerIndex &&
              wardrobeDimZ === 45 &&
              wardrobePlusOne !== undefined
            ) {
              setShifts({ shift: !shifts.shift, left: false, right: true });
            }
          }
        }
        if (cornerIndex > activeWardrobe) {
          if (wardrobesConfigs[activeWardrobe + 2] !== undefined) {
            if (activeWardrobe === 0 && wardrobePlusOne !== undefined) {
              setShifts({ shift: !shifts.shift, left: false, right: true });
            }
            if (wardrobesConfigs[activeWardrobe + 2].dimensions.z === 45 || wardrobeDimZ === 45) {
              setShifts({ shift: !shifts.shift, left: true, right: false });
            }
            if (
              activeWardrobe > 0 &&
              wardrobePlusOneDimZ === wardrobeDimZ &&
              activeWardrobe + 1 !== cornerIndex
            ) {
              setShifts({ shift: !shifts.shift, left: true, right: true });
            }
            if (
              (activeWardrobe === 0 && activeWardrobe + 1 === cornerIndex && wardrobeDimZ === 45) ||
              (activeWardrobe === 0 &&
                activeWardrobe + 1 === cornerIndex &&
                wardrobeDimZ === 66 &&
                wardrobePlusTwoDimZ === 45)
            ) {
              setShifts({ shift: !shifts.shift, left: false, right: false });
            }
          } else {
            if (activeWardrobe === 0 && wardrobeDimZ === 45) {
              setShifts({ shift: !shifts.shift, left: false, right: false });
            }
            if (activeWardrobe === 0 && wardrobePlusOne !== undefined) {
              setShifts({ shift: !shifts.shift, left: false, right: true });
            }
            if (activeWardrobe > 0 && wardrobePlusOne !== undefined) {
              setShifts({ shift: !shifts.shift, left: true, right: true });
            }
            if (activeWardrobe + 1 === cornerIndex && wardrobeDimZ === 45) {
              setShifts({ shift: !shifts.shift, left: true, right: false });
            }
          }
        }
        if (activeWardrobe === cornerIndex) {
          if (x === 97) {
            if (wardrobeMinusOne !== undefined && wardrobePlusOne !== undefined) {
              if (wardrobeMinusOneDimZ === 66 && wardrobePlusOneDimZ === 45) {
                setShifts({ shift: !shifts.shift, left: false, right: false });
              }
              if (wardrobeMinusOneDimZ === 66 && wardrobePlusOneDimZ === 66) {
                setShifts({ shift: !shifts.shift, left: true, right: true });
              }
            }
            if (wardrobeMinusOne !== undefined && wardrobePlusOne === undefined) {
              if (wardrobeMinusOneDimZ === 66) {
                setShifts({ shift: !shifts.shift, left: true, right: false });
              } else {
                setShifts({ shift: !shifts.shift, left: false, right: false });
              }
            }
            if (wardrobePlusOne !== undefined && wardrobeMinusOne === undefined) {
              if (wardrobePlusOneDimZ === 66) {
                setShifts({ shift: !shifts.shift, left: false, right: true });
              } else {
                setShifts({ shift: !shifts.shift, left: false, right: false });
              }
            }
          }
          if (x === 66) {
            if (wardrobeMinusOne !== undefined && wardrobePlusOne !== undefined) {
              if (wardrobeMinusOneDimZ === 45 && wardrobePlusOneDimZ === 66) {
                setShifts({ shift: !shifts.shift, left: false, right: false });
              }
              if (wardrobeMinusOneDimZ === 66 && wardrobePlusOneDimZ === 66) {
                setShifts({ shift: !shifts.shift, left: true, right: true });
              }
            }
            if (wardrobeMinusOne !== undefined && wardrobePlusOne === undefined) {
              if (wardrobeMinusOneDimZ === 66) {
                setShifts({ shift: !shifts.shift, left: true, right: false });
              } else {
                setShifts({ shift: !shifts.shift, left: false, right: false });
              }
            }
            if (wardrobePlusOne !== undefined && wardrobeMinusOne === undefined) {
              if (wardrobePlusOneDimZ === 66) {
                setShifts({ shift: !shifts.shift, left: false, right: true });
              } else {
                setShifts({ shift: !shifts.shift, left: false, right: false });
              }
            }
          }
        }
      }
    } else {
      if (activeWardrobe === 0) {
        setShifts({ shift: !shifts.shift, left: false, right: true });
      }
      if (wardrobes - 1 === activeWardrobe) {
        setShifts({ shift: !shifts.shift, left: true, right: false });
      }
      if (wardrobePlusOne !== undefined && wardrobeMinusOne !== undefined) {
        setShifts({ shift: !shifts.shift, left: true, right: true });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeWardrobe]);

  const {
    activeFront,
    activeFrontPattern,
    activeFronts,
    cornerIndexes,
    dimensions,
    width,
    height,
    depth,
    opened,
    activeZone,
  } = state;

  const { slidePoints } = props;

  const children = React.Children.map(props.children, child => {
    if (!!child) {
      return React.cloneElement(child, {
        activeFront: activeFront,
        activeFrontPattern: activeFrontPattern,
        activeFronts: activeFronts,
        slidePoints: slidePoints ?? [],
        cornerIndexes: cornerIndexes,
        bodyColorList: [],
        frontColorList: [],
        handleColorList: [],
        wardrobeHulls: [],
        cornerTypes: [],
        configuratorMode: currentConfiguratorMode,
        actualWidth: width,
        actualHeight: height,
        actualDepth: depth,
        wardrobesConfigs: wardrobesConfigs,
        activeWardrobe: activeWardrobe,
        moveSegment: moveSegment,
        changeBodyType: changeBodyType,
        addWardrobe: addWardrobe,
        setHighlightedWardrobe: setHighlightedWardrobe,
        setNotHighlightedWardrobe: setNotHighlightedWardrobe,
        shoppingList: wardrobesConfigs,
        setWardrobes: setWardrobes,
        setOpenDoorsState: setOpenDoorsState,
        setWardrobesConfigs: setWardrobesConfigs,
        setWardrobeActive: setWardrobeActive,
        changeConfiguratorMode: changeConfiguratorMode,
        setActiveFrontsPanels: setActiveFrontsPanels,
        setFrontPattern: setFrontPattern,
        activeZone: activeZone,
      });
    }
  });
  return (
    <div id="brw-configurator" className="configurator">
      <div className="configurator__relative">
        {status === LoaderState.LOADING && <Loader />}
        <BrwScene
          ref={brwSceneRef}
          activeFronts={activeFronts}
          activeFront={activeFront}
          pathname={props.location.pathname}
          setOverallWidth={setOverallWidth}
          dimensions={state.dimensions}
          orbitMode={state.orbitMode}
          highlightedWardrobe={state.highlightedWardrobe}
          notHighlightedWardrobe={state.notHighlightedWardrobe}
          opened={state.opened}
          configuratorMode={currentConfiguratorMode}
          activeWardrobe={state.activeWardrobe}
          changeStatus={changeStatus}
          setWardrobeActive={setWardrobeActive}
          refreshLabels={refreshLabels}
          refreshScene={refreshScene}
          addWardrobe={addWardrobe}
          setZone={setZone}
          activeZone={activeZone}
          changeConfiguratorMode={changeConfiguratorMode}
          setActiveFrontPanel={setActiveFrontPanel}
        />
        {props.location.pathname === '/summary' && (
          <ConfiguratorControlButtons
            addWardrobe={addWardrobe}
            toggleOpen={toggleOpen}
            toggleDimensions={toggleDimensions}
            dimensions={dimensions}
            opened={opened}
          />
        )}

        {optionsVisibility.optionsButton === true && (
          <WardrobeOptionsButtons
            editSegment={action => {
              editSegment(action);
            }}
            changeConfiguratorMode={changeConfiguratorMode}
          />
        )}

        {props.location.pathname === '/wardrobe-body-configuration' &&
          (wardrobesConfigs[activeWardrobe].is_corner ? null : (
            <>
              <WardrobeIcon
                wardrobesDimensions={!wardrobesConfigs[activeWardrobe].is_hinged}
                popupName="door-info-popup"
              />
              {/* <PopUpButton
                icon={!wardrobesConfigs[activeWardrobe].is_hinged ? 'sliding-door' : 'hinged-door'}
                popupName="door-info-popup"
                wardrobesConfigs={wardrobesConfigs[activeWardrobe]}
              /> */}
              <PopUp popupName="door-info-popup" title="Rodzaj drzwi">
                <div className="container">
                  <DoorTypesPopupContent />
                </div>
              </PopUp>
            </>
          ))}
      </div>

      {currentConfiguratorMode === 8 && (
        <div className="edit-buttons-panel">
          <div className="edit-buttons-container">
            {wardrobesConfigs.map((config, index) => {
              return optionsVisibility.printMode ? null : (
                <EditButton
                  wardrobeConfig={wardrobesConfigs[index]}
                  measurements={measurements(wardrobesConfigs)}
                  width={config.dimensions.x}
                  key={index}
                  index={index}
                  setWardrobeActive={() => setWardrobeActive(index)}
                />
              );
            })}
          </div>
        </div>
      )}
      {currentConfiguratorMode === 10 && <MoveWardrobe moveSegment={moveSegment} />}

      {children}
    </div>
  );
};
const MemoConfigurator = React.memo(Configurator);
export default withRouter(MemoConfigurator);
